import { PopoverPlacement } from "@idui/react-popover";
import { FC, ReactElement } from "react";

import { FramerTooltip } from "@ryde/controls";

import { StructureTooltipContent } from "./ai-conversation-details.styled";

interface IStructureNodeTooltipProps {
  content: string;
  children: ReactElement;
}

export const StructureNodeTooltip: FC<IStructureNodeTooltipProps> = ({
  content,
  children,
}) => {
  if (!content) {
    return children;
  }

  return (
    <FramerTooltip
      placement={PopoverPlacement.right}
      content={<StructureTooltipContent>{content}</StructureTooltipContent>}
      mouseEnterDelay={300}
    >
      {children}
    </FramerTooltip>
  );
};
